import { combineReducers } from 'redux'
import { solidRate } from './solidRateReducer'
import { atomicMass } from './atomicMassReducer'
import { densityCorrection } from './densityCorrectionReducer'
import { unitConverter } from './unitConverterReducer'
import { processYield } from './processYieldReducer'
import { so3Correction } from './so3CorrectionReducer'
import { propertyTable } from './propertyTableReducer'
import { news } from './newsReducer'
import { files } from './filesReducer'

export default combineReducers({
    formulas: combineReducers({
        solidRate,
        atomicMass,
        densityCorrection,
        unitConverter,
        processYield,
        so3Correction,
        propertyTable
    }),
    news,
    files
})